import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetRubDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_RUBs_DETAILS, token);
  return res;
};

export const GetRubDetail = async (rubId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_RUBs_DETAILS + rubId, token);
  return res;
};

export const AddRub = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_RUBs, payload, token);
  return res;
};

export const DeleteRub = async (rubId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_RUBs + rubId, rubId, token);
  return res;
};

export const UpdateRub = async (rubId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_RUBs + rubId, payload, token);
  return res;
};
